// The ARRL 33 cm (902-928 MHz) band plan, transcribed from arrl.org/band-plan
// on 2026-09-11. ARRL's own note: locally coordinated plans always take
// precedence over this national recommendation, so a regional plan belongs in
// a user scheme.

import type { Scheme } from '../scheme.ts'

export const ARRL_33CM_ID = 'arrl-33cm'

const MHz = 1e6

export function arrl33cmScheme(): Scheme {
  return {
    id: ARRL_33CM_ID,
    name: 'ARRL 33 cm band plan',
    source: 'https://www.arrl.org/band-plan',
    builtin: true,
    channels: [],
    bands: [
      { label: 'Repeater inputs / weak signal', lowHz: 902.0 * MHz, highHz: 902.075 * MHz, group: 'FM/other or CW/SSB' },
      { label: 'Weak signal', lowHz: 902.075 * MHz, highHz: 902.1 * MHz, group: 'CW/SSB' },
      { label: 'Weak signal', lowHz: 902.1 * MHz, highHz: 902.125 * MHz, group: 'CW/SSB' },
      { label: 'Repeater inputs', lowHz: 902.125 * MHz, highHz: 903.0 * MHz, group: 'FM/other incl. DV' },
      { label: 'Beacons, weak signal', lowHz: 903.0 * MHz, highHz: 903.1 * MHz, group: 'CW/SSB' },
      { label: 'Weak signal', lowHz: 903.1 * MHz, highHz: 903.4 * MHz, group: 'CW/SSB' },
      { label: 'Mixed modes, control links', lowHz: 903.4 * MHz, highHz: 909.0 * MHz, group: 'Mixed' },
      { label: 'Broadband multimedia', lowHz: 909.0 * MHz, highHz: 915.0 * MHz, group: 'Analog/digital' },
      { label: 'Broadband multimedia', lowHz: 915.0 * MHz, highHz: 921.0 * MHz, group: 'Analog/digital' },
      { label: 'Broadband multimedia', lowHz: 921.0 * MHz, highHz: 927.0 * MHz, group: 'Analog/digital' },
      { label: 'Repeater outputs', lowHz: 927.0 * MHz, highHz: 927.075 * MHz, group: 'FM/other incl. DV' },
      { label: 'Simplex', lowHz: 927.075 * MHz, highHz: 927.125 * MHz, group: 'FM/other incl. DV' },
      { label: 'Repeater outputs', lowHz: 927.125 * MHz, highHz: 928.0 * MHz, group: 'FM/other incl. DV' },
    ],
    markers: [
      { label: 'CW/SSB calling', hz: 902.1 * MHz },
      { label: 'CW/SSB calling', hz: 903.1 * MHz },
    ],
  }
}
